import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import { layoutKey, OrdersLayout } from './config';

const read = (userId: string | undefined): OrdersLayout => {
    try {
        return userId && localStorage.getItem(layoutKey(userId)) === 'table' ? 'table' : 'board';
    } catch {
        return 'board';
    }
};

/** Board or table, remembered per signed-in user in localStorage['qo.orders.view.<userId>']. */
export function useOrdersLayout(): [OrdersLayout, (next: OrdersLayout) => void] {
    const userId = useSelector((s: RootState) => s.auth.user?.id);
    const [layout, setLayout] = useState(() => read(userId));
    const set = useCallback(
        (next: OrdersLayout) => {
            setLayout(next);
            try {
                if (userId) localStorage.setItem(layoutKey(userId), next);
            } catch {
                // storage unavailable: the choice lasts for this visit only
            }
        },
        [userId]
    );
    return [layout, set];
}
